import { render, staticRenderFns } from "./BipRoads1.vue?vue&type=template&id=892573ac&scoped=true&"
import script from "./BipRoads1.vue?vue&type=script&lang=js&"
export * from "./BipRoads1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892573ac",
  null
  
)

export default component.exports